import { Frame } from '../../domain/entities/Frame';
import { Cuboid } from '../../domain/entities/Cuboid';
import type { RawFrameData, RawCuboid } from '../../domain/ports/FrameRepository';
import type { PointCloudData } from '../../domain/value-objects/PointCloudData';

function parsePointCloud(points: [number, number, number][]): PointCloudData {
  const count = points.length;
  const positions = new Float32Array(count * 3);

  for (let i = 0; i < count; i++) {
    positions[i * 3] = points[i][0];
    positions[i * 3 + 1] = points[i][1];
    positions[i * 3 + 2] = points[i][2];
  }

  return { positions, count };
}

function parseCuboid(raw: RawCuboid): Cuboid {
  return new Cuboid(
    raw.uuid,
    { x: raw['position.x'], y: raw['position.y'], z: raw['position.z'] },
    { width: raw['dimensions.x'], height: raw['dimensions.y'], depth: raw['dimensions.z'] },
    { yaw: raw.yaw },
    {
      label: raw.label,
      stationary: raw.stationary,
      cameraUsed: raw.camera_used,
      siblingId: raw['cuboids.sibling_id'] ?? '',
      sensorId: raw['cuboids.sensor_id'] ?? -1,
    },
  );
}

export function parseFrame(raw: RawFrameData): Frame {
  const pointCloud = parsePointCloud(raw.points);
  const cuboids = new Map<string, Cuboid>();

  for (const rawCuboid of raw.cuboids) {
    const cuboid = parseCuboid(rawCuboid);
    cuboids.set(cuboid.uuid, cuboid);
  }

  return new Frame(raw.frame_id, pointCloud, cuboids);
}
